<fv-modal #modal [size]="FV_MODAL_SIZE.xl" [modalPosition]="FV_MODAL_POSITION.center" [opaqueBackground]="false"
  [isBackgroundCloseModal]="true" [showIconClose]="false" [footerPosition]="FV_MODAL_FOOTER_POSITION.end"
  [isFooterHidden]="true" [isHeaderHidden]="true">
  <div body #body class="flex flex-col gap-1 mt-10 mb-10 overflow-y-auto max-h-[70vh] no-scrollbar">
    <div class="flex">
      <fv-button class="fixed z-[200] min-w-[95px] bottom-6 right-10 md:!right-16" (click)="scrollToBottom()"
        name="cache-button" [color]="BUTTON_COLOR.glassWhite" [size]="BUTTON_SIZE.sm" [type]="BUTTON_TYPE.outline">
        {{ 'GO TO BOTTOM' }}
      </fv-button>
    </div>

    <div *ngFor="let log of currentLogs()">
      <hr class="opacity-30">
      <div class="flex-col gap-2">
        <div class="inline-flex gap-2">
          <p class="text-zinc-500 drop-shadow-sm">
            {{log.timestamp}}
          </p>
          <p class="text-white drop-shadow-sm">
            {{log.message}}
          </p>
        </div>
        <pre
          class="m-0 p-0 text-purple-300 drop-shadow-sm whitespace-pre-wrap break-words max-w-full">{{parseJsonString(log.customData)}}</pre>
      </div>
    </div>
  </div>
</fv-modal>